<template>
    <div class="box flex wrap center">
        <div class="data flex wrap center" @click="$emit('onclick')">
            <div class="status flex wrap center vcenter"
                :class="[{ 'green': [113, 102, 103].includes(entity?.status) }, { 'orange': entity?.status === 100 || entity?.status === 111 }]">
                <p>{{ entity?.status === 100
                    ? 'درحال تأمین مالی'
                    : entity?.status === 111
                        ? 'در انتظار بازگشایی'
                        : [113, 102, 103].includes(entity?.status)
                            ? 'تأمین مالی شد'
                            : 'در انتظار تائید' }}</p>
            </div>
            <div class="symbol">
                <p>نماد طرح: {{ entity?.folder_symbol }}</p>
            </div>
            <div class="banner">
                <img v-lazy="image || '/images/projectoverviewbanner.webp'" :alt="entity?.folder_name" loading="lazy" />
            </div>
            <div class="title flex wrap start vcenter">
                <h4 :class="{ 'slide': slide }">{{ entity?.folder_name }}</h4>
            </div>
            <div class="subtitle flex wrap end vcenter">
                <div>
                    <h6>{{ entity?.folder_company_name }}</h6>
                </div>
            </div>
            <div :class="[{ 'extras flex wrap center': !simple }]">
                <div v-if="simple" class="description"
                    :class="[{ 'progress': !((simple || !progress) && (!entity?.progress || (entity?.progress && entity?.progress === 'False'))) }]"
                    v-html="entity?.description">
                </div>
                <div v-else class="properties flex wrap center">
                    <div class="flex wrap center vcenter">
                        <p>نرخ سود پیش بینی شده {{ entity?.interest_rate }} درصد</p>
                    </div>
                    <div class="flex wrap center vcenter">
                        <p>دوره سرمایه گذاری {{ entity?.folder_period }} ماهه</p>
                    </div>
                    <div class="flex wrap center vcenter">
                        <p>تقسیم سود به صورت {{ entity?.folder_dividend_period }}</p>
                    </div>
                    <div v-if="entity?.deeds" class="flex wrap center vcenter">
                        <p>{{ entity?.deeds }}</p>
                    </div>
                </div>
                <div v-if="(simple || !progress) && (!entity?.progress || (entity?.progress && entity?.progress === 'False'))"
                    class="investors">
                    <p>{{ `سرمایه گذاری شده توسط ${data?.uid || 0} شخص حقیقی و حقوقی` }}</p>
                </div>
                <Progress v-else :entity="entity" :data="data"></Progress>
            </div>
        </div>
        <div v-if="route" class="action flex wrap center vcenter">
            <a @click.prevent="$emit('invest')">
                <button>{{ view || 'مشاهده جزئیات و سرمایه گذاری' }}</button>
            </a>
        </div>
        <div v-else class="action flex wrap center vcenter">
            <a :href="`/Project/${entity?.id}`" target="_blank">
                <button>{{ entity?.status === 100 ? 'مشاهده جزئیات و سرمایه گذاری' : 'مشاهده جزئیات طرح' }}</button>
            </a>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Progress from './Progress.vue'

export default {
    name: 'CardView',
    props: ['entity', 'data', 'simple', 'progress', 'route', 'view'],
    inject: ['base'],
    components: { Progress },
    created() {
        this.base.API().getAsArrayBuffer(`Identities/Folder/Download?uid=${this.entity?.id}&key=image`
            , (response) => {
                try {
                    const decoder = new TextDecoder('utf-8')
                    const json = decoder.decode(response.data)
                    JSON.parse(json)
                } catch (e) {
                    this.image = `data:image/webp;base64,${btoa(String.fromCharCode(...new Uint8Array(response.data)))}`
                }
            }, (error) => {

            })
    },
    data() {
        return {
            slide: true,
            image: null
        }
    }
}
</script>

<style src="../assets/css/components/cardview.css"></style>